api = require('../api.coffee').api()

class global.CarouselResource extends ResourceBase
  @MODEL = Carousel
  @SINGULAR_RESOURCE_NAME = 'carousel'
  @PLURAL_RESOURCE_NAME = 'carousels'
  
  
  create_or_update: (success, failure, params) ->
    api.post '/carousels/create_or_update', params, { success: @memberSuccess(success), failure }

  show: (success, failure, params={}) ->
    api.get '/carousels', params, { success: @memberSuccess(success), failure}



// WEBPACK FOOTER //
// ./src/resources/carousel.coffee